const branding = {
  goto: {
    logo: new URL("../assets/images/logo2.png", import.meta.url).href,
    desktopHeaderLogo: new URL("../assets/images/logo.png", import.meta.url)
      .href,
    mobileIconeMenu: new URL("../assets/images/icon-menu.png", import.meta.url)
      .href,
    terms_an_conditions:"terms_an_conditions_goto",
    privacy_policy: "privacy_policy_goto",
    faq: "faq_goto",
    contact_us: "contact_us_goto",
    appleStore:
      "https://apps.apple.com/us/app/goto-car2go-shared-mobility/id1449036622",
    googlePlay: "https://play.google.com/store/apps/details?id=moveo.GoTo",
    favicon: new URL("../../favicon.ico", import.meta.url).href,
    join: "join_goto",
    registrationLink: "https://join.gotoglobal.com/israel"
  },
  autotel: {
    logo: new URL("../assets/images/logo_atl.png", import.meta.url).href,
    desktopHeaderLogo: new URL("../assets/images/logo_atl.png", import.meta.url)
      .href,
    mobileIconeMenu: new URL(
      "../assets/images/icon-menu-atl.png",
      import.meta.url,
    ).href,
    terms_an_conditions:"terms_an_conditions_atl",
    privacy_policy: "privacy_policy_atl",
    faq: "faq_atl",
    contact_us: "contact_us_atl",
    appleStore: "https://apps.apple.com/us/app/autotel-אוטותל/id1208454186",
    googlePlay:
      "https://play.google.com/store/apps/details?id=com.car2go.autotel",
    favicon: new URL("../assets/images/logo_atl.png", import.meta.url).href,
    join: "",
    registrationLink: ""
  },
}

export default branding
